module.exports = __webpack_public_path__ + "img/page3-bg.721d98f1.png";